export enum ProcessType {
    Lead,
    Award,
    Disbursement,
    Status,
    PaymentPeriod,
    Document
}
